/* 🤖 this file was generated by svg-to-ts */
export const iccIconViewGrid: {
  name: 'view_grid';
  data: string;
} = {
  name: 'view_grid',
  data: `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M11.25 7.25h-4v4h4v-4ZM16.75 7.25h-4v4h4v-4ZM11.25 12.75h-4v4h4v-4ZM16.75 12.75h-4v4h4v-4Z" fill="currentColor"/><path d="M20 4H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2Zm0 14H4V6h16v12Z" fill="currentColor"/></svg>`
};
